import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFieldPath } from "../../Common/SchemaUtils";

const DateFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
}> = ({ extractionId, extractionPath, label }) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}`}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          {...field}
          value={dayjs(field.value)}
          onChange={(newValue) =>
            field.onChange(newValue?.format("YYYY-MM-DD"))
          }
          label={label}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              fullWidth: true,
              helperText: error ? error.message : "",
              error: !!error,
              size: "small",
            },
          }}
        />
      )}
    />
  );
};

export default DateFormFields;
